import { Url } from "../../url/source/Url";

export default class DateTool {
	constructor(){
	}

    // DateTool.newDate();
    public static newDate(dateStr:any=null, inputMonth:number=null, inputDay:number=null):Date{
        if ( dateStr === null ) {
            return new Date();
        }


        if ( inputDay !== null ) {
            return new Date(dateStr, inputMonth, inputDay);
        }else if ( inputMonth !== null ){
            return new Date(dateStr, inputMonth);
        }
        if ( isNaN(Number(dateStr)) ) {
            var a:any = dateStr.split(/[^0-9]/);
            if (  a[3] === undefined ) {
                a[3] = 0;
            }
            if (  a[4] === undefined ) {
                a[4] = 0;
            }
            if (  a[5] === undefined ) {
                a[5] = 0;
            }

            return new Date(a[0],a[1]-1,a[2],a[3],a[4],a[5] );
        }
        return new Date(dateStr);
    }

    public static getMonth(date:Date=null):string{
        if (  date === null ) {
            date = DateTool.newDate();
        }
        var temp:string = (date.getMonth()+1).toString();
        return DateTool.formatMonth(temp);
    }

    public static formatMonth(temp: string):string {
        if (temp.length < 2) {
            temp = '0' + temp;
        }
        return temp;
    }
    public static formatDay(temp: string):string {
        if ( temp.length < 2 ) {
            temp = '0' + temp;
        }
        return temp;
    }

    public static getDay(date:Date=null):string{
        if (  date === null ) {
            date = DateTool.newDate();
        }
        var temp:string = date.getDate().toString();
        if ( temp.length < 2 ) {
            temp = '0' + temp;
        }
        return temp;
    }

    public static getDayName(date:Date=null, lang:string='hu'):string{
        let names = DateTool.getDayNames(lang);
        if (  date === null ) {
            date = DateTool.newDate();
        }
        return names[date.getDay()];
    }

    public static modifyDate(month:number, currentDate:string|Date=undefined):Date {
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) {
                date = DateTool.newDate();
            }else if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
                date = DateTool.newDate(this.convertDateToEUDate(currentDate.substr(0,10)));
            }

        }
        return DateTool.newDate(date.setMonth(date.getMonth() + month));
    }

    public static modifyDateWithDay(day:number, currentDate:string|Date=undefined):Date {
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) {
                date = DateTool.newDate();
            }else if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
                date = DateTool.newDate(this.convertDateToEUDate(currentDate.substr(0,10)));
            }

        }
        return DateTool.newDate(date.setDate(date.getDate() + day));
    }

    public static modifyDateWithHour(hour:number, currentDate:string|Date=undefined):Date {
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) {
                date = DateTool.newDate();
            }else if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
                date = DateTool.newDate(currentDate);
            }

        }
        let modifiedDate = date.setHours(date.getHours() + hour);
        return new Date(modifiedDate);
    }

    public static getYear(date:Date=null):string{
        if (  date === null ) {
            date = DateTool.newDate();
        }
        return date.getFullYear().toString();
    }

    public static convertDateToEUDate(currentDate:string|Date){
        if ( currentDate instanceof Date ) {

        }else{
            if ( currentDate.indexOf('.') > -1 ) {
                var temp = currentDate.split('.');
                currentDate = temp[0]+'-'+temp[1]+'-'+temp[2];
            }else if ( currentDate.indexOf('/') > -1 ) {
                var temp = currentDate.split('/');
                currentDate = temp[2]+'-'+temp[0]+'-'+temp[1];
            }
        }
        return currentDate;
    }

    public static convertDateToUSADate(currentDate:string):string{
        if ( currentDate.indexOf('.') > -1 ) {
            var temp = currentDate.split('.');
            currentDate = temp[1]+'/'+temp[2]+'/'+temp[0];
        }else if ( currentDate.indexOf('-') > -1 ) {
            var temp = currentDate.split('-');
            currentDate = temp[1]+'/'+temp[2]+'/'+temp[0];
        }
        return currentDate;
    }

	public static getDate(currentDate?:string|Date, lang:string='hu', usaFormat:boolean=false){
        if (  currentDate === null ) {
            currentDate = undefined;
        }

        if ( currentDate instanceof Date ) {

        }else{
            if ( currentDate != undefined ) {
                currentDate = this.convertDateToEUDate(currentDate);
            }
        }

        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) return '';
            if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
                date = DateTool.newDate(this.convertDateToEUDate(currentDate.substr(0,10)));
            }

        }
        let dateStr = date.getFullYear() + '-' + this.getMonth(date) + '-' + this.getDay(date);
        if ( usaFormat === true ) {
            return  this.convertDateToUSADate(dateStr);
        }

        return dateStr;
    }

	public static getDateHu(currentDate?:string|Date, withEndPoint:boolean=true){
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) return '';
            if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
            date = DateTool.newDate(currentDate.substr(0,10).replace(/\./g, '-'));
        }

        }
        return date.getFullYear() + '.' + this.getMonth(date) + '.' + this.getDay(date) + (withEndPoint===true?'.':'');
    }

    public static getDateTime(currentDate?:string|Date){
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) return '';
            if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
            date = DateTool.newDate(currentDate.replace(/\./g, '-'));
        }

        }
        return date.getFullYear() + '-' + this.getMonth(date) + '-' + this.getDay(date) + ' ' + this.hoursFormat(date.getHours()) +':'+ this.minutesFormat(date.getMinutes());
    }
    public static getDateTimeSec(currentDate?:string|Date){
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) return '';
            if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
            date = DateTool.newDate(currentDate.replace(/\./g, '-'));
        }

        }
        return date.getFullYear() + '-' + this.getMonth(date) + '-' + this.getDay(date) + ' ' + this.hoursFormat(date.getHours()) +':'+ this.minutesFormat(date.getMinutes())+':00';
    }

    public static hoursFormat(input:number):string{
        let temp = input.toString();
        if ( temp.length < 2 ) {
            temp = '0' + temp;
        }
        return temp;
    }
    public static minutesFormat(input:number):string{
        let temp = input.toString();
        if ( temp.length < 2 ) {
            temp = '0' + temp;
        }
        return temp;
    }

    public static getDateTimeHu(currentDate?:string|Date, withEndPoint:boolean=true){
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) return '';
            if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
            date = DateTool.newDate(currentDate.substr(0,10).replace(/\./g, '-'));
        }

        }
        return date.getFullYear() + '.' + this.getMonth(date) + '.' + this.getDay(date) +  (withEndPoint===true?'. ':'') + this.hoursFormat(date.getHours()) +':'+ this.minutesFormat(date.getMinutes());
    }

    public static getMonthsList():Array<string>{
        return [
            'Január',
            'Február',
            'Március',
            'Április',
            'Május',
            'Június',
            'Július',
            'Augusztus',
            'Szeptember',
            'Október',
            'November',
            'December'
        ]
    }

    public static getDayNames(lang:string='hu'):Array<string>{
        switch (lang) {
            case 'en':
                return [
                    "Sunday", "Monday", "Tuesday", "Wednesday", "Thrusday", "Friday", "Saturday"
                ]
        }

        return [
            "Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"
        ]
    }

    public static getYearsList():Array<number>{
        let ret = [];
        let currentYear:number = parseInt(this.getYear());

        let min = currentYear - 100;
        for (let index = currentYear; index > min; --index) {
            ret.push(index);

        }
        return ret;
    }

    public static getWeek(currentDate?:string|Date):number{
        if ( currentDate instanceof Date ) {

        }else{
            if ( currentDate != undefined && currentDate.indexOf('.') > -1 ) {
                var temp = currentDate.split('.');
                currentDate = temp[0]+'-'+temp[1]+'-'+temp[2];
            }
        }

        var date:Date = null;
        if ( currentDate === undefined ) {
            date = DateTool.newDate();
        }else{
            if ( currentDate === '' ) return 0;
            if ( currentDate instanceof Date ) {
                date = currentDate;
            }else{
                date = DateTool.newDate(currentDate.substr(0,10).replace(/\./g, '-'));
            }

        }
        var onejan = DateTool.newDate(date.getFullYear(),0,1);
        return Math.ceil((
            ( (date.valueOf() - onejan.valueOf()) / 86400000 ) + onejan.getDay()+1)/7);
    }

    public static parse(dateStr:string):number{
        dateStr = DateTool.getDateTimeSec(dateStr);
        if ( Url.isSafari(true) ) {
            let modifiedDate = DateTool.modifyDateWithHour(-1,dateStr);
            dateStr = DateTool.getDateTime(modifiedDate);
            dateStr = dateStr.replace(' ', 'T');
        }else if ( Url.isIOS() ) {
            dateStr = DateTool.getDateTime(dateStr);
            dateStr = dateStr.replace(' ', 'T');
        }
        let tms = Date.parse(dateStr);
        return tms;
    }
}
new DateTool();
